import {authRequest} from './index.js'

export async function get_traits(){
  let data
  await authRequest.get(
    '/traits'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_module(trait_id){
  let data
  await authRequest.get(
    '/traits/' + trait_id + '/show_module'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_max_val(trait_id){
  let data
  await authRequest.get(
    '/traits/' + trait_id + '/max_value'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}